import { render, staticRenderFns } from "./supplierDetail.vue?vue&type=template&id=93311e7a&scoped=true"
import script from "./supplierDetail.vue?vue&type=script&lang=js"
export * from "./supplierDetail.vue?vue&type=script&lang=js"
import style0 from "./supplierDetail.vue?vue&type=style&index=0&id=93311e7a&prod&lang=scss&scoped=true"
import style1 from "./supplierDetail.vue?vue&type=style&index=1&id=93311e7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93311e7a",
  null
  
)

export default component.exports